import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpUtilService } from "../http-util.service";

const SERVICE_NAME = "OpenCategoryCoeDepositorService.asmx";

@Injectable({
  providedIn: "root",
})
export class OpenCategoryCoeDepositoryService {
  constructor(private http: HttpUtilService) {}

  add(model: any): Observable<any> {
    const payload = { model };
    return this.http.post(`/${SERVICE_NAME}/Add`, payload);
  }

  moveOrRetrieve(model: any): Observable<any> {
    const payload = { model };
    return this.http.post(`/${SERVICE_NAME}/MoveOrRetrive`, payload);
  }
}
